<template>
  <div v-if="show" class="toast" :class="type">
    {{ message }}
  </div>
</template>

<script setup>
defineProps({
  show: {
    type: Boolean,
    default: false
  },
  message: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'success',
    validator: (value) => ['success', 'error', 'info', 'warning'].includes(value)
  }
})
</script>

<style scoped>
.toast {
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  animation: toast-slide-up 0.3s ease-out;
}

.toast.success {
  background: var(--color-heading);
  color: var(--color-background);
}

.toast.error {
  background: var(--color-error);
  color: white;
}

.toast.info {
  background: var(--color-text);
  color: var(--color-background);
}

.toast.warning {
  background: #f59e0b;
  color: white;
}

@keyframes toast-slide-up {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
</style>